import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { PROJECT_IMAGES } from "@/lib/brand";
import { TID } from "@/constants/testIds/dv";

export const About = () => {
  const { t } = useLanguage();
  const bullets = ["about.bullet_1", "about.bullet_2", "about.bullet_3", "about.bullet_4"];

  return (
    <section
      id="about"
      data-testid={TID.aboutSection}
      className="bg-[#0A0A0A] text-white py-24 md:py-32 relative overflow-hidden"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-20 items-center">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-10 bg-[#E63946]" />
            <span className="label-eyebrow">{t("about.eyebrow")}</span>
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight leading-[0.95]">
            {t("about.title")}
          </h2>
          <p className="mt-6 text-white/75 leading-relaxed text-base">{t("about.p1")}</p>
          <p className="mt-4 text-white/65 leading-relaxed text-base">{t("about.p2")}</p>

          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-3 border border-white/10 p-3 rounded-sm">
                <div className="h-5 w-5 mt-0.5 grid place-items-center bg-[#E63946] rounded-sm">
                  <Check className="h-3.5 w-3.5 text-white" />
                </div>
                <span className="text-sm text-white/85">{t(b)}</span>
              </li>
            ))}
          </ul>

          <a
            href="#contact"
            data-testid={TID.aboutCta}
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="mt-10 inline-flex items-center gap-2 text-white border-b-2 border-[#E63946] pb-1 font-semibold uppercase tracking-[0.2em] text-sm hover:text-[#E63946] transition-colors"
          >
            {t("about.cta")} <ArrowRight className="h-4 w-4" />
          </a>
        </div>

        {/* Image collage */}
        <div className="relative grid grid-cols-6 grid-rows-6 gap-3 h-[480px] md:h-[560px]">
          <img
            src={PROJECT_IMAGES[1].src}
            alt=""
            className="col-span-4 row-span-4 w-full h-full object-cover rounded-sm border border-white/10"
          />
          <img
            src={PROJECT_IMAGES[2].src}
            alt=""
            className="col-span-2 row-span-3 w-full h-full object-cover rounded-sm border border-white/10"
          />
          <div className="col-span-2 row-span-3 bg-[#E63946] rounded-sm border border-white/10 p-4 flex flex-col justify-between">
            <div className="font-display text-4xl md:text-5xl font-bold leading-none">10+</div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/90">
              years on the job
            </div>
          </div>
          <img
            src={PROJECT_IMAGES[0].src}
            alt=""
            className="col-span-4 row-span-2 w-full h-full object-cover rounded-sm border border-white/10"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
